"use client";

import Script from "next/script";
import { initializeLogger } from ".";
import { getManageTripsObservabilityData } from "./observability";

export type FeLoggerClientProperties = {
  src: string;
  subscriptionKey: string;
};
export const FeLoggerClient = ({
  src,
  subscriptionKey,
}: FeLoggerClientProperties) => (
  <Script
    onReady={() => {
      const additionalData = getManageTripsObservabilityData(
        document.location.pathname,
      );

      const runInitialization = initializeLogger({
        additionalData,
        subscriptionKey,
      });

      runInitialization();
    }}
    src={src}
  />
);
